var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-row col-12 p-0"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }